import { Check, Palette } from 'lucide-react';

export type TurbanColour = {
  id: string;
  name: string;
  hex: string;
  rgb: [number, number, number];
};

export const turbanColours: TurbanColour[] = [
  { id: 'deep-maroon', name: 'Deep Maroon', hex: '#7f263b', rgb: [127, 38, 59] },
  { id: 'royal-blue', name: 'Royal Blue', hex: '#2457c5', rgb: [36, 87, 197] },
  { id: 'emerald-green', name: 'Emerald Green', hex: '#16805d', rgb: [22, 128, 93] },
  { id: 'saffron', name: 'Saffron', hex: '#e78b1e', rgb: [231, 139, 30] },
  { id: 'pastel-pink', name: 'Pastel Pink', hex: '#efb6c3', rgb: [239, 182, 195] },
  { id: 'cream', name: 'Cream', hex: '#e9dfcc', rgb: [233, 223, 204] },
  { id: 'dusty-pink', name: 'Dusty Pink', hex: '#c8878e', rgb: [200, 135, 142] },
  { id: 'classic-red', name: 'Classic Red', hex: '#c4414c', rgb: [196, 65, 76] },
  { id: 'navy', name: 'Navy', hex: '#183a59', rgb: [24, 58, 89] },
  { id: 'black', name: 'Black', hex: '#191b20', rgb: [25, 27, 32] },
  { id: 'earth-brown', name: 'Earth Brown', hex: '#8f5c3f', rgb: [143, 92, 63] },
  { id: 'gold', name: 'Gold', hex: '#c79a4c', rgb: [199, 154, 76] },
  { id: 'bottle-green', name: 'Bottle Green', hex: '#1d5144', rgb: [29, 81, 68] },
];

type ColourPickerProps = {
  value: string;
  name: string;
  busy?: boolean;
  onChange: (colour: TurbanColour) => void;
  resultMode?: boolean;
};

export function ColourPicker({ value, name, busy = false, onChange, resultMode = false }: ColourPickerProps) {
  return (
    <section className={resultMode ? 'mt-6 rounded-2xl border border-border bg-card p-5 sm:p-6' : ''} aria-labelledby={resultMode ? 'result-colour-title' : undefined} data-testid={resultMode ? 'panel-result-colour' : 'panel-colour-picker'}>
      {resultMode && <div className="flex items-start gap-3"><span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-secondary/20 text-primary"><Palette size={17} /></span><div><p className="mono-font text-[10px] uppercase tracking-[.16em] text-primary">Keep the style, change the mood</p><h3 id="result-colour-title" className="display-font mt-2 text-2xl">Try another colour</h3><p className="mt-2 text-sm leading-6 text-muted-foreground">The turban fabric is recoloured deterministically while your fit and selfie stay unchanged.</p><p className="mt-3 text-sm font-semibold text-foreground" data-testid="text-result-selected-colour">Current colour: {name}</p></div></div>}
      <div className={resultMode ? 'mt-5 flex flex-wrap gap-2' : 'flex flex-wrap gap-3'}>
        {turbanColours.map((colour) => <button key={colour.name} type="button" disabled={busy} onClick={() => onChange(colour)} className={`flex items-center gap-2 rounded-full border px-4 py-2 text-sm transition disabled:cursor-not-allowed disabled:opacity-50 ${name === colour.name || value === colour.hex ? 'border-primary bg-primary/10 text-primary' : 'border-border bg-card hover:border-primary/50'}`} data-testid={`${resultMode ? 'button-result-colour-' : 'button-colour-'}${colour.name.toLowerCase().replaceAll(' ', '-')}`}><span className="h-5 w-5 rounded-full border border-background shadow-sm" style={{ backgroundColor: colour.hex }} />{colour.name}{(name === colour.name || value === colour.hex) && <Check size={14} />}</button>)}
      </div>
    </section>
  );
}